import { render, staticRenderFns } from "./FinishedOrderSummaryModal.vue?vue&type=template&id=eeeb2a80&"
import script from "./FinishedOrderSummaryModal.vue?vue&type=script&lang=ts&"
export * from "./FinishedOrderSummaryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QTable,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QTable,QCardActions})
